import type { useTheme } from './theme';
import { headerStyles } from './styles/headerStyles';
import { restStyles } from './styles/restStyles';
import { entryStyles } from './styles/entryStyles';
import { dropsetStyles } from './styles/dropsetStyles';
import { stepperStyles } from './styles/stepperStyles';
import { inputStyles } from './styles/inputStyles';

// Logger modal styles factory. Originally extracted from
// LoggerScreen.tsx in 1.59.4; split into namespaced partials under
// ./styles/ in Track R (the single sheet had crossed 1.4k lines and no
// longer fit a read window). This barrel preserves the public
// `makeStyles(theme)` shape exactly — every consumer is unchanged — by
// merging the per-cluster partials into one object.
export function makeStyles(theme: ReturnType<typeof useTheme>) {
  return {
    ...headerStyles(theme),
    ...restStyles(theme),
    ...entryStyles(theme),
    ...dropsetStyles(theme),
    ...stepperStyles(theme),
    ...inputStyles(theme),
  };
}
